import { useCallback, useContext, useEffect, useState } from 'react'

import { Text, Button, RadioButton } from '@cash-me/react-components'

import { billsClient } from 'src/adapters/http'
import { pushDataLayer } from 'utils/push-data-layer'

import { DuplicateBillContext } from '..'
import type { DuplicateBillContextProps } from '../types'

import * as S from './styles'

export const MfaOptions = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { fields, changeCallback, routeCallback } = useContext<DuplicateBillContextProps>(DuplicateBillContext)
  const options = fields.mfaOptions

  const handleClickNotMyInfo = () => {
    pushDataLayer({
      category: 'Clique',
      action: 'Sou cliente',
      label: `Link Não é meu e-mail ou número de celular`
    })
    routeCallback('info', { type: 'not-my-info' })
  }

  const handleSubmit = useCallback(async () => {
    if (!fields.mfaSelectedOption) return

    setIsLoading(true)

    try {
      const { data } = await billsClient.getMFA({
        contrato: fields.contract,
        documento: fields.document,
        tipo: fields.mfaSelectedOption
      })
      changeCallback('mfaId', data.id)

      routeCallback('mfa-code')
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      routeCallback('info', {
        type: 'server-error'
      })
    } finally {
      setIsLoading(false)
    }
  }, [fields, changeCallback, routeCallback])

  useEffect(() => {
    pushDataLayer({
      category: 'Visualização',
      action: 'Sou cliente',
      label: `Formulário Opções MFA`
    })
  }, [])

  return (
    <S.Form>
      <S.OptionsTitle>
        <Text size="heading5" weight="medium" color="var(--colors-neutral-text-default)">
          Para a sua segurança, confirme que é realmente você.
        </Text>
        <Text size="body1" color="var(--colors-neutral-text-default)">
          Escolha um método abaixo para receber o código de verificação:
        </Text>
      </S.OptionsTitle>
      <S.OptionsWrapper>
        {options &&
          options.map((option, index) => (
            <RadioButton
              key={`mfa-option-${index}`}
              checked={fields.mfaSelectedOption === option.tipo}
              name="mfa-option"
              value={option.tipo}
              onChange={() => changeCallback('mfaSelectedOption', option.tipo)}
            >
              {option.valor}
            </RadioButton>
          ))}

        <S.Link onClick={() => handleClickNotMyInfo()}>
          <Text as="span" size="body2" color="var(--colors-blue-text-default)">
            Não é meu e-mail ou número de celular
          </Text>
        </S.Link>
      </S.OptionsWrapper>

      <Button
        size="lg"
        type="button"
        variants="text-only"
        loading={isLoading}
        disabled={!fields.mfaSelectedOption}
        onClick={handleSubmit}
      >
        Receber código
      </Button>

      <S.BackButtonWrapper>
        <S.Link onClick={() => routeCallback('form')}>
          <Text size="body1" weight="medium" color="var(--colors-blue-text-default)">
            Voltar
          </Text>
        </S.Link>
      </S.BackButtonWrapper>
    </S.Form>
  )
}
